import { POST, PUT, GET, ApiUrl } from '@/config/index'

// 首页-我的供应
const getMySupplyData = POST(`${ApiUrl}/web/process/api/backapp/process/web/statistics/action/mySupply`)

// 首页-我的需求
const getMyDemandData = POST(`${ApiUrl}/web/process/api/backapp/process/web/statistics/action/myDemand`)

// 首页-我的服务订单
const getMySupplyOrder = POST(`${ApiUrl}/web/process/api/backapp/process/web/statistics/action/mySupplyOrder`)

// 首页-我的需求订单
const getMyDemandOrder = POST(`${ApiUrl}/web/process/api/backapp/process/web/statistics/action/myDemandOrder`)

// 首页-认证状态查询
const getCertification = POST(`${ApiUrl}/web/process/api/backapp/process/web/certification/action/getCertification`)

// 首页-个人认证查询
const getCertificateInfo = GET(`${ApiUrl}/web/process/api/backapp/process/web/personalCertification/action/getCertificateInfo`)

// 首页-个人认证撤销
const personalCertificateCancel = GET(`${ApiUrl}/web/process/api/backapp/process/web/personalCertification/action/cancel`)

// 首页-个人认证重新提交
const resubmitPersonalCertificate = PUT(`${ApiUrl}/web/process/api/backapp/process/web/personalCertification/`)

// 首页-个人认证
const personalCertification = POST(`${ApiUrl}/web/process/api/backapp/process/web/personalCertification/`)

// 首页-企业认证
const enterpriseCertification = POST(`${ApiUrl}/web/process/api/backapp/process/web/enterpriseCertification/`)

// 首页-企业认证查询
const getEnterpriseCertificateInfo = GET(`${ApiUrl}/web/process/api/backapp/process/web/enterpriseCertification/action/getCertificateInfo`)

// 首页-企业认证撤销
const enterpriseCertificationCancel = GET(`${ApiUrl}/web/process/api/backapp/process/web/enterpriseCertification/action/cancel`)

// 首页-企业认证重新提交
const resubmitEnterpriseCertification = PUT(`${ApiUrl}/web/process/api/backapp/process/web/enterpriseCertification/`)

// 获取收藏列表
const getCollectList = POST(`${ApiUrl}/web/process/api/backapp/process/web/favorites/action/queryByPage`)

// 取消收藏
const cancelCollect = POST(`${ApiUrl}/web/process/api/backapp/process/web/favorites/action/deleteById`)

// 获取我的需求列表不同状态数量
const getDemandCount = POST(`${ApiUrl}/web/process/api/backapp/process/web/demand/action/queryCountByStatus`)

// 获取我的需求列表
const getDemandList = POST(`${ApiUrl}/web/process/api/backapp/process/web/demand/action/queryByPage`)

// 我的需求-下架
const outDemand = PUT(`${ApiUrl}/web/process/api/backapp/process/web/demand/`)

// 我的需求-上架
const putawayDemand = PUT(`${ApiUrl}/web/process/api/backapp/process/web/demand/`)

// 我的需求-删除
const deleteDemand = POST(`${ApiUrl}/web/process/api/backapp/process/web/demand/action/deleteById`)

// 我的需求-详情
const getDemandDetail = POST(`${ApiUrl}/web/process/api/backapp/process/web/demand/action/detail`)

// 我的需求-品类树结构
const getDemandCategory= GET(`${ApiUrl}/web/process/api/backapp/process/web/category/action/queryProcessCategory`)

// 我的需求-发布
const publishDemand = POST(`${ApiUrl}/web/process/api/backapp/process/web/demand/`)

// 我的需求-编辑
const editDemand = PUT(`${ApiUrl}/web/process/api/backapp/process/web/demand/`)

// 需求订单-订单列表
const getDemandOrderList = POST(`${ApiUrl}/web/process/api/backapp/process/web/order/action/queryDemandOrder`)

// 需求订单-评价订单
const evaluateDemandOrder = POST(`${ApiUrl}/web/process/api/backapp/process/web/order/action/evaluate`)

// 需求订单-取消订单
const cancelDemandOrder = POST(`${ApiUrl}/web/process/api/backapp/process/web/order/action/buyerCancel`)

// 需求订单-修改
const modifyDemandOrder = PUT(`${ApiUrl}/web/process/api/backapp/process/web/order/`)

// 需求订单-从新下单
const demandReorder = POST(`${ApiUrl}/web/process/api/backapp/process/web/order/action/reOrder`)

// 需求订单-订单数量
const getDemandOrderCount = POST(`${ApiUrl}/web/process/api/backapp/process/web/order/action/queryDemandOrderCount`)

// 服务订单-订单列表
const getServiceOrderList = POST(`${ApiUrl}/web/process/api/backapp/process/web/order/action/querySupplyOrder`)

// 服务订单-订单数量
const getServiceOrderCount = POST(`${ApiUrl}/web/process/api/backapp/process/web/order/action/querySupplyOrderCount`)

// 服务订单-维护服务进度
const serviceProgress = POST(`${ApiUrl}/web/process/api/backapp/process/web/order/action/progress`)

// 服务订单-回复订单
const replServiceOrder = POST(`${ApiUrl}/web/process/api/backapp/process/web/order/action/reply`)

// 服务订单-取消订单
const cancelServiceOrder = POST(`${ApiUrl}/web/process/api/backapp/process/web/order/action/sellerCancel`)

// 服务订单-订单完成
const finishedServiceOrder = POST(`${ApiUrl}/web/process/api/backapp/process/web/order/action/finished`)

// 供应管理-我的服务情况
const getMyService = POST(`${ApiUrl}/web/process/api/backapp/process/web/demand/action/getMyService`)

// 农机预约-我的预约列表
const getMyAppointment = POST(`${ApiUrl}/web/argimach/api/argimach/web/appointment/action/myAppointment`)

// 农机预约-我的预约列表数量
const getMyAppointmentCount = POST(`${ApiUrl}/web/argimach/api/argimach/web/appointment/action/myAppointmentCount`)

// 农机预约-我的预约-评价
const appointmentEvaluate = POST(`${ApiUrl}/web/argimach/api/argimach/web/appointment/action/modify`)

export default {
    getMySupplyData,
    getMyDemandData,
    getMySupplyOrder,
    getMyDemandOrder,
    getCertification,
    getCertificateInfo,
    personalCertificateCancel,
    resubmitPersonalCertificate,
    personalCertification,
    enterpriseCertification,
    getEnterpriseCertificateInfo,
    enterpriseCertificationCancel,
    resubmitEnterpriseCertification,
    getCollectList,
    cancelCollect,
    getDemandCount,
    getDemandList,
    outDemand,
    putawayDemand,
    deleteDemand,
    getDemandDetail,
    getDemandCategory,
    publishDemand,
    editDemand,
    getDemandOrderList,
    evaluateDemandOrder,
    cancelDemandOrder,
    modifyDemandOrder,
    demandReorder,
    getDemandOrderCount,
    getServiceOrderList,
    getServiceOrderCount,
    serviceProgress,
    replServiceOrder,
    cancelServiceOrder,
    finishedServiceOrder,
    getMyService,
    getMyAppointment,
    getMyAppointmentCount,
    appointmentEvaluate
}
